<template>
  <div class="hello">
    
    <h1>{{ $t('sendMessage') }}</h1>
    <p>
      {{ $t('introduction') }}
    </p>
    <p>{{ $t('recipientEmail') }}: <input v-model="email" /></p>
    <p>{{ $t('sendDate') }}: <input v-model="date" /></p>
    <p>{{ $t('message')}}:<br/> <textarea v-model="message" /></p>
    <button v-on:click="orderDelayedEmail">{{ $t('order') }}</button>
    <p v-if="messageReceived">{{ $t('orderMessage') }}: {{ messageReceived }}</p>
  </div>
</template>

<script>
export default {
  name: 'SendMessage',
  data: function() {
    return {
      messageReceived: '',
      message: '',
      date: '',
      email: ''
    }
  },
  methods: {
    orderDelayedEmail: function () {
      fetch(window.location.protocol + "//" + window.location.host + "/api/orderEmailSending?email="+ this.email + "&message=" + this.message + "&date=" + this.date)
      .then(response => response.json())
      .then(json => {
        this.messageReceived = json,
        this.message = '',
        this.date = '',
        this.email = ''
      })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "sendMessage": "Leave a message!"
    , "introduction": "Here You can order to send e-mail at a specific time."
    , "recipientEmail": "Recipient e-mail"
    , "sendDate": "Date when sent"
    , "message": "Message"
    , "order": "Order"
    , "orderMessage": "Ordered email to be sent"
  },
  "pl": {
    "sendMessage": "Zostaw wiadomość!"
    , "introduction": "Tutaj możesz zlecić wysłanie e-maila w określonym dniu."
    , "recipientEmail": "E-mail odbiorcy"
    , "sendDate": "Termin wysłania"
    , "message": "Treść wiadomości"
    , "order": "Zamów"
    , "orderMessage": "Zamówiony email"
  }
}
</i18n>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
